module.exports = __webpack_public_path__ + "static/media/14.cc40d9a1.jpg";